import { idiomaAtual, t } from '../i18n/idioma';
import { nomeDaSkill } from '../i18n/nomes';

const TETO = 100;

interface Props {
  title: string;
  skills: readonly { id: string; value: number; startValue: number }[];
  onCancel(): void;
}

function oneDecimal(n: number): string {
  return n.toLocaleString(idiomaAtual(), { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

/** Gump da sessão: lista no molde do perfil, com o ganho desta sessão. */
export function DummyTrainGump({ title, skills, onCancel }: Props) {
  return (
    <div className="treino">
      <p className="treino__titulo">{title}</p>
      <div className="profile-skills__list treino__lista">
        {skills.map(skill => {
          const atual = Math.min(TETO, Math.max(0, skill.value));
          const ganho = Math.max(0, atual - skill.startValue);
          return (
            <div key={skill.id} className="profile-skill">
              <span className="profile-skill__name">{nomeDaSkill(skill.id)}</span>
              <span className="profile-skill__val">
                {oneDecimal(atual)}
                {ganho > 0 && (
                  <em className="treino__ganho"> {t('manequim.ganho', { n: oneDecimal(ganho) })}</em>
                )}
              </span>
              <div
                className="profile-skill__bar"
                role="meter"
                aria-label={nomeDaSkill(skill.id)}
                aria-valuenow={atual}
                aria-valuemin={0}
                aria-valuemax={TETO}
              >
                <div style={{ width: `${atual}%` }} />
              </div>
            </div>
          );
        })}
      </div>
      <button type="button" className="treino__cancel" data-nodrag onClick={onCancel}>
        {t('manequim.cancelar')}
      </button>
    </div>
  );
}
